<template>
  <div @mouseover="onMouseover"
       @mouseleave="onMouseleave"
       class="corptips"
  >
    {{ texts.corpClientTips }}
    <a :href="texts.corpClientTipsLink" target="_blank">{{ texts.corpClientTipsLinkText }}</a>.
    <div class="corptips__text" v-if="show">{{ texts.corpClientTipsHint }}</div>
  </div>
</template>

<script>
import MobileDetect from 'mobile-detect';

export default {
  name: 'CorpClientTips',
  data() {
    return {
      show: false,
      mobileDetect: null,
    };
  },
  mounted() {
    this.mobileDetect = new MobileDetect(window.navigator.userAgent);
  },
  computed: {
    texts() {
      return {
        corpClientTips: this.$t('CorpClientTips'),
        corpClientTipsLinkText: this.$t('CorpClientTipsLinkText'),
        corpClientTipsLink: this.$t('CorpClientTipsLink'),
        corpClientTipsHint: this.$t('CorpClientTipsHint'),
      };
    },
  },
  methods: {
    isMobile() {
      const isMobile = this.mobileDetect.mobile();
      const isPhone = this.mobileDetect.phone();
      const isTablet = this.mobileDetect.tablet();

      return isMobile || isPhone || isTablet;
    },
    onMouseover() {
      this.show = !this.isMobile();
    },
    onMouseleave() {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.corptips {
  font-size: 20px;
  font-weight: 300;
  text-align: center;
  margin: 20px 0 60px;
  position: relative;

  @media (max-width: 768px) {
    font-size: 18px;
    margin: 20px 0 20px;
  }

  a {
    text-decoration: underline;
    font-weight: bold;
    color: inherit;

    &:hover {
      text-decoration: none;
    }
  }

  &__text {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 10px);

    padding: 12px;
    color: #999999;
    font-size: 11px;
    line-height: 1.181818;
    text-align: center;
    background-color: #262626;
    border-radius: 4px 4px 0 4px;
    transition: opacity .25s, visibility .25s;

    &:after {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -100%);
      top: 0;
      display: block;
      content: "";
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-bottom: 10px solid #262626;
    }
  }
}
</style>
